import { Alert } from "@mui/material";

const NewsPageNotLiveDialogAlert = () => (
  <Alert severity="warning">
    Investors won&apos;t see this communication until the News page is set to Live in Investor Portal Settings.
  </Alert>
);

export default NewsPageNotLiveDialogAlert;
